import type { StatusDefinition } from "@kontextwerk/web-sdk/core/display/status"
import { mdiProgressClock } from "@mdi/js"

import {
  contactOrderStepStatusInfo,
  displayContactOrderStepStatusLabel,
} from "../../../../../../../_shared/_logic/outreach-presentation"

type ContactStepExecutionStatusMeta = (typeof contactOrderStepStatusInfo)[ContactStepPhase]

export const contactStepExecutionStatusInfo: Record<
  ContactStepPhase,
  ContactStepExecutionStatusMeta
> = {
  ...contactOrderStepStatusInfo,
  BLOCKED: {
    ...contactOrderStepStatusInfo.BLOCKED,
    label: "Noch nicht dran",
    description: "Wartet auf vorherigen Schritt.",
  },
  WAITING: {
    ...contactOrderStepStatusInfo.WAITING,
    label: "Wartet auf Antwort",
    description: "Kontakt wurde gestartet. Jetzt wird auf Rückmeldung gewartet.",
  },
  CANCELED: {
    ...contactOrderStepStatusInfo.CANCELED,
    label: "Abgebrochen",
    description: "Dieser Schritt wurde abgebrochen.",
  },
}

export const resolveContactStepExecutionStatusInfo = (
  status?: string | null,
): ContactStepExecutionStatusMeta => {
  const normalized = String(status || "").toUpperCase() as ContactStepPhase

  return (
    contactStepExecutionStatusInfo[normalized] ?? {
      label: displayContactOrderStepStatusLabel(status),
      description: status
        ? "Status ist nicht bekannt."
        : "Status ist aus einer Kommunikation abgeleitet.",
      tone: "var(--text-invers-100)",
      color: "blue",
      icon: mdiProgressClock,
    }
  )
}

export const buildContactStepExecutionStatusDefinition = (
  status?: string | null,
): StatusDefinition<string> => {
  const info = resolveContactStepExecutionStatusInfo(status)

  return {
    value: String(status || "UNKNOWN"),
    label: info.label,
    color: info.color,
    icon: info.icon,
    description: info.description,
  }
}

export const contactStepExecutionStatusTooltip = Object.values(contactStepExecutionStatusInfo)
  .map(({ label, description }) => `${label}: ${description}`)
  .join("\n")
